export default "__VITE_ASSET__CXh6vD1r__"